const PRESIDENT = "President";
const VICE_PRESIDENT = "Vice President";

export default {
    PRESIDENT,
    VICE_PRESIDENT
}